module.exports = __webpack_public_path__ + "static/portfolio-dfce64eba754c033668f6c9e9d4aece7.gif";